import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import { getChallanDetail, saveChallanPrint } from '../order.services';
import { Grid } from '@mui/material';
import { LABOR_SPECS_MAP, MATERIAL_SPECS_MAP, PROCESS_SPECS_MAP, SpecListItem } from '../../master-data/specs/specs.mapping';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import { TYPE_LABOR, TYPE_MATERIAL, TYPE_PROCESS } from '../../common/constants';
import { isChecking, isPacking } from '../../common/util.services';
import IForm from '../../../components/i-form/i-form.component';

const PrintChallanForm = (props: any) => {
  const appContext = useContext(AppContext);
  const [specList, setSpecList] = useState<any>([]);
  const [loader, setLoader] = useState(true);
  const [challanData, setChallanData] =  useState<any>({});
  
  useEffect(() => {
    getChallanDetail(props.detailId, appContext,
      (response: any) => {
        setChallanData(response.data);
        setLoader(false);
        appContext.setShowLoader(false);
        setSpecs(response.data.type, response.data.input);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        setLoader(false);
      });
  }, []);

  const onSubmit = (data: any) => {
    saveChallanPrint(data, appContext,
      (response: any) => {
        setLoader(false);
        appContext.setShowLoader(false);
        props.close();
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        setLoader(false);
      });
  }

  const onCancel = () => {
    props.close();
  }

  function setSpecs(type: any, input: any) {
    if (type === TYPE_MATERIAL) {
      setSpecList(MATERIAL_SPECS_MAP[input]);
    } else if (type === TYPE_PROCESS) {
      setSpecList(PROCESS_SPECS_MAP[input]);
    } else if (type === TYPE_LABOR) {
      if(isChecking(input)) {
        setSpecList(LABOR_SPECS_MAP['Checking']);
      } else if(isPacking(input)) {
        setSpecList(LABOR_SPECS_MAP['Packing']);
      } else {
        setSpecList(LABOR_SPECS_MAP['Bale Packing']);
      }
    }
  };

  const getMainComponent = () => {
    return (
      <Grid container spacing={0} maxWidth={800}>
        <Grid xs={3}> <ITextField name='hsnCode' label='HSN Code' required={true} /></Grid>
        <Grid xs={3}> <ITextField name='description' label='Description' /></Grid>
        {specList.map((spec: SpecListItem) => {
            return <Grid xs={3}> <ITextField name={spec.fieldObject} label={spec.fieldName} disabled={'spec14' === spec.fieldObject} /></Grid>
        })}
      </Grid>
    );
  }

  return loader ? <></> : <IForm formData={challanData} title={''} submitForm={onSubmit} cancelForm={onCancel}
                           cancelNavigation = {false} mainComponent={getMainComponent()}></IForm>
}

export default PrintChallanForm;